// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"77":"1eac270cb393d1a13e69","702":"7662dc23ed1c93108277","715":"34dd6ecb43cd754170af"}[chunkId] + ".css";
};